// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fVTJe","input":"styles_input__3mHFV"};